import AWS from 'aws-sdk'
import { DynamoApi } from './dynamo'
import { QueryOptions } from './types2'
import ItemList = AWS.DynamoDB.ItemList
import QueryOutput = AWS.DynamoDB.QueryOutput

// TODO migrar todo a este. Ir agregando metodos a medida que sea necesario.
// Pero la idea es reusar query lo maximo posible.
export const useDynamoActions2 = () => {
    return (dynamoApi: DynamoApi, tKeyValue?: string) => {
        const queryLoop = async (
            dbTableName: string,
            options?: QueryOptions
        ): Promise<QueryOutput> => {
            const { startKey, limit, count = false } = options || {}
            const items: ItemList = []
            let totalCount = 0
          
            let lastKey = startKey
            let queryLimit = limit && Math.max(limit * 30, 300)

            while (!limit || totalCount < limit + 1) {
                const response = await dynamoApi.query(
                    dbTableName,
                    tKeyValue!,
                    {
                        ...(options || {}),
                        startKey: lastKey,
                        limit: queryLimit
                    }
                )

                if (count) {
                    totalCount += response.Count ?? 0
                } else if (response.Items?.length) {
                    items.push(...response.Items)
                    totalCount = items.length
                }

                const pageLength = count ? (response.Count ?? 0) : (response.Items ?? []).length
                if (limit && pageLength < limit / 2) {
                    queryLimit = Math.min(queryLimit! * 2, 1000)
                }

                lastKey = response.LastEvaluatedKey
                if (!lastKey) break
            }

            return {
                ...(count ?
                    { Count: totalCount } :
                    { Items: items }),
                LastEvaluatedKey: lastKey
            }
        }

        const getMultiple = async (
            dbTableName: string,
            options?: QueryOptions
        ) => {
            return queryLoop(dbTableName, options)
        }

        const count = async (
            dbTableName: string,
            options?: QueryOptions
        ) => {
            return queryLoop(dbTableName, {
                ...(options || {}),
                count: true
            })
        }

        return {
            getMultiple,
            count
        }
    }
}
